import React, { Component } from "react";

export default class Task extends Component {
  render() {
    return (
      <div {...this.props} className={`task card flex center space-btw ${this.props.className}`}  svg={false}>
        <div className="left flex center">
          <div className="icon flex center">{this.props.svg}</div>
          <div>
            <div className="text">
              <div className="title">{this.props.title}</div>
            </div>
          </div>
        </div>
        <div className="arrw">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.2441 5.58925C9.91864 5.26381 9.91864 4.73617 10.2441 4.41073C10.5695 4.0853 11.0972 4.0853 11.4226 4.41073L16.4226 9.41073C16.7381 9.72622 16.7491 10.2342 16.4476 10.5631L11.8643 15.5631C11.5533 15.9024 11.0262 15.9253 10.6869 15.6143C10.3476 15.3033 10.3247 14.7762 10.6357 14.4369L14.6799 10.0251L10.2441 5.58925Z"
              fill="#E40587"
            />
            <path
              opacity="0.3"
              d="M4.41072 5.58925C4.08529 5.26381 4.08529 4.73617 4.41072 4.41073C4.73616 4.0853 5.2638 4.0853 5.58923 4.41073L10.5892 9.41073C10.9047 9.72622 10.9158 10.2342 10.6143 10.5631L6.03094 15.5631C5.71995 15.9024 5.19281 15.9253 4.85354 15.6143C4.51428 15.3033 4.49136 14.7762 4.80235 14.4369L8.84653 10.0251L4.41072 5.58925Z"
              fill="#E40587"
            />
          </svg>
        </div>
      </div>
    );
  }
}
